import { AuthHeading } from '@/bundle/Auth/ui/AuthHeading/AuthHeading';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { AcceptedAgreementDetails } from '@/bundle/shared/components/MasterServiceAgreement/AcceptedAgreementDetails/AcceptedAgreementDetails';
import { MasterServiceAgreementWidget } from '@/bundle/shared/components/MasterServiceAgreement/MasterServiceAgreementWidget';
import { formatReactStringToHTMLString } from '@/bundle/shared/components/MasterServiceAgreement/const';
import { Box } from '@/components/Box/Box';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/components/Notification/Notification';
import { formatDate, FULL_MONTH_DATE_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { getInternalOrganizationMasterServiceAgreementDetails } from './api/api';

export const MasterServiceAgreementPage = () => {
  const navigate = useNavigate();

  const { data, isPending } = useQuery({
    queryKey: ['get_internal_master_service_agreement_details'],
    queryFn: () => getInternalOrganizationMasterServiceAgreementDetails(),
  });

  const masterServiceAgreementDetails = data?.body;
  const modifiedDate = formatDate(masterServiceAgreementDetails?.agreement?.date_version, FULL_MONTH_DATE_FORMAT);
  const error = getResponseError(data?.error);

  return (
    <AuthLayout position='top' isLoading={isPending}>
      <AuthHeading
        header='Master Services Agreement'
        subHeader='This page provides a record of the accepted Master Service Agreement.'
      />
      {error && <Notification variant='error'>{error}</Notification>}

      {masterServiceAgreementDetails && (
        <MasterServiceAgreementWidget
          header='Master Services Agreement'
          modifiedDate={modifiedDate}
          actionSlot={<AcceptedAgreementDetails details={masterServiceAgreementDetails} modifiedDate={modifiedDate} />}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: formatReactStringToHTMLString(masterServiceAgreementDetails?.agreement.agreement_html),
            }}
          />
        </MasterServiceAgreementWidget>
      )}
      <Box margin='42px 0 12px' mobile={{ margin: '32px 0' }}>
        <NavigationLink to={''} onClick={() => navigate(-1)}>
          {'< Return to Organization Details'}
        </NavigationLink>
      </Box>
    </AuthLayout>
  );
};
